import classNames from 'classnames';
import { DayCardProps } from '../types';
import styles from '../cards.module.css';
import { WeatherIcon } from '../../../utils/commons/getWeatherIcon';

const DayCard = (props: DayCardProps) => {
    const { weather } = props;

    return (
        <div className={classNames(styles.forecastCard)}>
            <h3 className={styles.forecastCardDate}>{weather.day}</h3>
            <div className={styles.forecastCardInfo}>
                <div className={styles.forecastCardIcon}>
                    <WeatherIcon weather={weather.weather} />
                </div>
                <div className={styles.forecastCardTemperature}>
                    <strong>{weather.high}°</strong>
                    <span>{weather.low}°</span>
                </div>
            </div>
        </div>
    );
};

export { DayCard };